import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof CmsMasterData;
  onSort: (property: keyof CmsMasterData) => void;
}

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const headCells: { id: keyof CmsMasterData; label: string }[] = [
  { id: "PageTitle", label: "Page URL" },
  { id: "MetaTitle", label: "Page Title" },
  { id: "MetaKeyword", label: "Meta Keyword" },
  { id: "MetaDesc", label: "Meta Description" },
  { id: "HeaderName1", label: "Header Name 1" },
  { id: "HeaderName2", label: "Header Name 2" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof CmsMasterData) => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      <TableCell align="left" sx={commonCellStyle}>
        Action
      </TableCell>

      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          align="left"
          sx={commonCellStyle}
          sortDirection={orderBy === headCell.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
